var CollapsibleBundle = class extends HTMLElement {
  constructor() {
    super();

    this.collapsibles = this.querySelectorAll('collapsible-content');
    this.settings = JSON.parse(this.getAttribute('data-settings'));
  }

  closeAll() {
    for (const collapsible of this.collapsibles) {
      if (collapsible.isExpanding || collapsible.el.open) {
        collapsible.shrink();
      }
    }
  }
}

var CollapsibleContent = class extends HTMLElement {
  constructor() {
    super();
    this.el = this.querySelector('details');

    this.summary = this.el.querySelector('summary');
    this.content = this.el.querySelector('.accordion__content');

    this.bundleContainer = this.closest('collapsible-bundle');

    this.speed = 200;

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';

    if (this.isClosing || !this.el.open) {
      if (this.bundleContainer.settings.onlyOneOpen) {
        this.bundleContainer.closeAll();
      }
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;
    
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;
    
    if (this.animation) {
      this.animation.cancel();
    }
    
    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: this.speed,
      easing: 'ease-out'
    });
    
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;

    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    
    if (this.animation) {
      this.animation.cancel();
    }
    
    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: this.speed,
      easing: 'ease-out'
    });

    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.el.open = open;

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    
    this.el.style.height = this.el.style.overflow = '';
  }
}

if (typeof window.customElements.get('collapsible-content') === "undefined") {
  window.customElements.define('collapsible-bundle', CollapsibleBundle);
  window.customElements.define('collapsible-content', CollapsibleContent);
}